import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/checkoutredux/store/checkoutStore';

const BlockFooterV3: React.FC = () => {
  const totalFormat = useSelector(
    (state: RootState) => state.shoppingcart.metacartdata?.[0]?.totalpriceformat || ''
  );
  const notices = useSelector((state: RootState) => state.shoppingcart.noticedata || {});

  const getRelativeCheckoutURL = (): string => {
    return '../kasse/'; // Der relative Pfad zum Checkout
  };

  const getRelativeShoppingCartURL = (): string => {
    return '../warenkorb/'; // Der relative Pfad zum Warenkorb
  };

  const typeClassMapping = {
    error: 'ips-alert-error',
    notice: 'ips-alert-info',
    success: 'ips-alert-success',
  };

  const usedAlertIds: string[] = [];

  return (
    <>
      <div className="row p-2 mx-0 ips-sidecart-elementfooter-view2">
        <div className="ips-sidecart-footer-view2">
          <div className="col-12 p-0" style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
            <div className="row p-0 flex-grow-1">
              <div id="ips-alert-placeholder">
                <div className="ips-alert">
                  <div className="message"></div>
                </div>
              </div>

              <div id="ips-alert-container" className="woocommerce-notices-wrapper">
                {notices &&
                  Object.entries(notices).map(([type, messages]) =>
                    Array.isArray(messages) &&
                    messages.map((message, index) => {
                      const noticeText = message.notice_message || message;
                      const alertId = `${noticeText}${typeClassMapping[type]}${type}${index}`;
                      if (usedAlertIds.includes(alertId) || !noticeText) {
                        return null;
                      }
                      usedAlertIds.push(alertId);

                      return (
                        <div
                          key={alertId}
                          className={`ips-alert ${typeClassMapping[type]} ips-alert-${alertId}`}
                        >
                          <div className="message">{noticeText}</div>
                        </div>
                      );
                    })
                  )}
              </div>
            </div>
            <div className="row p-0 pe-2 flex-grow-0">
              <div className="col-6 p-0 ips-footer-subtotal">
                <strong>Zwischensumme:</strong>
              </div>
              <div className="col-3 p-0"></div>
              <div
                className="col-3 p-0 text-center ips-footer-totalprice"
                dangerouslySetInnerHTML={{ __html: totalFormat || '' }}
              ></div>
            </div>
            <div className="row g-0 p-0 flex-grow-0">
              <div className="ips-footer-textfield">
                <span>
                  Hier erfährst du mehr zu den
                  <a href="/versandkosten" target="_blank" rel="noopener noreferrer">
                    {' '}
                    Versandkosten
                  </a>
                  ,{' '}
                  <a href="/zahlungsweisen" target="_blank" rel="noopener noreferrer">
                    Zahlungsweisen
                  </a>{' '}
                  und unserer{' '}
                  <a href="/widerrufsbelehrung" target="_blank" rel="noopener noreferrer">
                    Widerrufsbelehrung
                  </a>
                  .
                </span>
              </div>
            </div>
            <div className="row g-0 p-0 flex-grow-0">
              <div className="ips-proceed-to-shoppingcart">
                <a
                  href={getRelativeShoppingCartURL()}
                  role="button"
                  className="ips-sidecart-primary-btn-view2 ips-sidecart-shoppingcart-btn"
                >
                  WARENKORB ANZEIGEN
                </a>
              </div>
              <div className="ips-proceed-to-checkout">
                <a
                  href={getRelativeCheckoutURL()}
                  role="button"
                  className="ips-sidecart-primary-btn-view2 ips-sidecart-checkout-btn-view2"
                >
                  KASSE
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BlockFooterV3;